import { useReducer } from 'react';
import {
  AddCastAndCrewContext,
  AddCastAndCrewProviderProps,
  castAndCrewReducer,
  initialCastAndCrewState,
} from './cast-and-crew.context';

const AddCastAndCrewProvider: React.FC<AddCastAndCrewProviderProps> = ({ children }) => {
  const [state, dispatch] = useReducer(castAndCrewReducer, initialCastAndCrewState);

  return <AddCastAndCrewContext.Provider value={{ state, dispatch }}>{children}</AddCastAndCrewContext.Provider>;
};

export default AddCastAndCrewProvider;
